import { render, staticRenderFns } from "./notice-edit.vue?vue&type=template&id=49314b54&scoped=true&"
import script from "./notice-edit.vue?vue&type=script&lang=js&"
export * from "./notice-edit.vue?vue&type=script&lang=js&"
import style0 from "./notice-edit.vue?vue&type=style&index=0&id=49314b54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49314b54",
  null
  
)

export default component.exports